// The account switcher is embedded in both the desktop and mobile sidebars, which
// are mounted simultaneously (the mobile one is only CSS-hidden, not v-if'd out) -
// dedupe so both instances share one in-flight request instead of firing separately.
let getLoginsRequest = null;

export default {
  getLogins: () => {
    if (!getLoginsRequest) {
      getLoginsRequest = $nuxt.$axios.get($nuxt.$api.host + '/logins').finally(() => {
        getLoginsRequest = null;
      });
    }

    return getLoginsRequest;
  },
  switchTo: (data) => $nuxt.$axios.post($nuxt.$api.host + '/me/switch-account', data),
  createImpersonationAccount: (account_uuid, data) => $nuxt.$axios.post($nuxt.$api.host + '/impersonated-login/' + account_uuid, data),
};
